import API from '../../constants/api';
import { isArrayValidAndNotEmpty, isValidText, ORDER_TYPE_DATE_FILTERS } from '../../constants/CommonUtil';

/**
 * Created by vinay on 26/8/19.
 */

const urgency = [
    { key: 'ON_SCHEDULED_DATE', value: 'On Scheduled Date' },
    { key: 'EMERGENCY', value: 'Emergency' },
    { key: 'IMMEDIATE', value: 'Immediate' },
    { key: 'URGENT', value: 'Urgent' },
    { key: 'ROUTINE', value: 'Routine' },
];

const commonFilter = [
    {
        name: 'doctor',
        label: 'Doctor',
        type: 'autocomplete',
        multiple: true,
        dataSourceApi: API.SEARCH.DOCTOR,
        dataSourceConfig: {
            text: 'value.value',
            value: 'key',
        },
    },
    {
        name: 'urgency',
        label: 'Priority',
        type: 'select',
        options: urgency,
        dataSourceConfig: {
            text: 'value',
            value: 'key',
        },
    },
];

const completedFilter = {
    name: 'showCompleted',
    label: 'Show Completed',
    type: 'checkbox',
    disableClear: true,
};

const excludedDoctorsFilter = {
    name: 'excludedDoctor',
    label: 'Excluded Doctor',
    type: 'autocomplete',
    multiple: true,
    dataSourceApi: API.SEARCH.DOCTOR,
    dataSourceConfig: {
        text: 'value.value',
        value: 'key',
    },
};

const reportedFilter = {
    name: 'showReported',
    label: 'Show Reported',
    type: 'checkbox',
    disableClear: true,
};

const discontinuedFilter = {
    name: 'showOnlyDiscontinued',
    label: 'Show Only Discontinued',
    type: 'checkbox',
    disableClear: true,
};

const QUEUE_FILTER_SCHEMA = (showDateFields, showCompletedField, orderType, showReported, isOrderTab = false, showOnlyDiscontinuedFilter) => {
    let filters = commonFilter;
    if (orderType) {
        filters = filters.concat({
            name: 'modality',
            label: 'Modality',
            type: 'select',
            dataSourceApi: `${API.SEARCH.ORDER_TYPE_MODALITIES}${orderType}`,
            dataSourceConfig: {
                text: 'value',
                value: 'key',
            },
        },
        );
    }
    if (showDateFields) {
        filters = filters.concat(
            {
                name: 'datePeriod',
                type: 'dateRange',
                label: 'Period',
                showOnTop: true,
                grid: '3',
                valueField: 'key',
                disableClear: true,
                options: Object.keys(ORDER_TYPE_DATE_FILTERS).map(aPeriod => ({
                    key: aPeriod,
                    value: ORDER_TYPE_DATE_FILTERS[aPeriod],
                })),
                defaultOption: {
                    key: 'LAST_10_DAYS',
                    value: 'Past 10 Days',
                },
            },
        );
    }

    if (isOrderTab) {
        filters = filters.concat(excludedDoctorsFilter);
    }
    if (showCompletedField) {
        filters = filters.concat(completedFilter);
    }
    if (showReported) {
        filters = filters.concat(reportedFilter);
    }
    if (showOnlyDiscontinuedFilter) {
        filters = filters.concat(discontinuedFilter);
    }
    return filters;
};

const vitalsDoctorFilter = {
    name: 'doctor',
    label: 'Doctor',
    type: 'autocomplete',
    multiple: false,
    dataSourceApi: API.SEARCH.DOCTOR,
    dataSourceConfig: {
        text: 'value.value',
        value: 'key',
    },
};

const period = [
    {
        name: 'datePeriod',
        type: 'dateRange',
        label: 'Period',
        valueField: 'key',
        disableClear: true,
        showOnTop: true,
        options: Object.keys(ORDER_TYPE_DATE_FILTERS).map(aPeriod => ({
            key: aPeriod,
            value: ORDER_TYPE_DATE_FILTERS[aPeriod],
        })),
        defaultOption: {
            key: 'LAST_10_DAYS',
            value: 'Past 10 Days',
        },
    },
];

export const showQueue = (location, routes) => isArrayValidAndNotEmpty(routes)
    && isValidText(location)
    && routes.some(route => location.includes(route));

export const VITALS_FILTER_SCHEMA = [vitalsDoctorFilter, completedFilter, ...period];

export default QUEUE_FILTER_SCHEMA;
